var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        class: _vm.$style.container
    }, [
        _c('van-checkbox', {
            class: _vm.$style.text,
            attrs: {
                "value": _vm.value,
                "shape": "square",
                "icon-size": "15px"
            },
            on: {
                "input": function($event) {
                    return _setup.emit('input', $event);
                }
            }
        }, [
            _c('span', [
                _vm._v("He leído y acepto el ")
            ]),
            _c('a', {
                class: _vm.$style.button,
                attrs: {
                    "href": "javascript:;"
                },
                on: {
                    "click": function($event) {
                        $event.stopPropagation();
                        return _setup.onOpenAgreement('user');
                    }
                }
            }, [
                _c('span', [
                    _vm._v("Acuerdo de Usuario")
                ])
            ]),
            _vm._v(" y el "),
            _c('a', {
                class: _vm.$style.button,
                attrs: {
                    "href": "javascript:;"
                },
                on: {
                    "click": function($event) {
                        $event.stopPropagation();
                        return _setup.onOpenAgreement('privacy');
                    }
                }
            }, [
                _c('span', [
                    _vm._v("Aviso de Privacidad")
                ])
            ])
        ]),
        _c(_setup.RegisterPrivacyPopup, {
            attrs: {
                "type": _setup.agreementType
            },
            model: {
                value: _setup.visibleMap.agreement,
                callback: function callback($$v) {
                    _vm.$set(_setup.visibleMap, "agreement", $$v);
                },
                expression: "visibleMap.agreement"
            }
        })
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
